import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"font-size":"14px","display":"flex","align-items":"center","color":"var(--oio-primary-color)"}
}

import { PlusOutlined } from '@ant-design/icons-vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MixinComponent',
  props: ['onAddRow', 'isDetailView'],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _renderSlot(_ctx.$slots, "default"),
    (!__props.isDetailView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_unref(PlusOutlined), { style: {"color":"var(--oio-primary-color)"} }),
          _createElementVNode("span", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (__props.onAddRow && __props.onAddRow(...args))),
            style: {"cursor":"pointer"}
          }, "添加一行")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})